import type React from "react";
import {Box, type SxProps, type Theme} from "@mui/material";
import DnbLogo from '~/icons/logo/DnB-logo.svg?react';
import MithraSourceLogo from '~/icons/logo/MithraSourceLogo.svg?react';
import SemanticVisionLogo from '~/icons/logo/SemanticVision.svg?react';
import {SOURCE_LOGO_LABEL, type SourceLogoKind} from "~/components/source-logo/sourceLogos";

const LOGO_SVG: Record<SourceLogoKind, React.FC<React.SVGProps<SVGSVGElement>>> = {
    mithra: MithraSourceLogo,
    semanticVision: SemanticVisionLogo,
    dnb: DnbLogo,
};

type SourceLogoProps = {
    source: SourceLogoKind;
    height?: number;
    sx?: SxProps<Theme>;
};

/** A data provider's logo (Mithra, Semantic Vision, Dun & Bradstreet), used in place of its name. */
export const SourceLogo: React.FC<SourceLogoProps> = ({source, height = 16, sx}) => {
    const Logo = LOGO_SVG[source];
    return (
        <Box
            component={Logo}
            role="img"
            aria-label={SOURCE_LOGO_LABEL[source]}
            sx={[{display: 'block', height, width: 'auto', flexShrink: 0, alignSelf: 'flex-start'}, ...(Array.isArray(sx) ? sx : [sx])]}
        />
    );
};
